module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/feature1@2x.1999a4b.jpg";